let timeoutId;
//in 24n hours, logout user
export const startSessionTimer = (logoutCallback, timeout = 60 * 24 * 60 * 1000) => {
    clearSessionTimer();
    timeoutId = setTimeout(() => {
        logoutCallback();
    }, timeout);

    // Listen for user activity to reset timer
    ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
        window.addEventListener(event, resetTimer, true);
    });
};

export const clearSessionTimer = () => {
    if (timeoutId) clearTimeout(timeoutId);
    ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
        window.removeEventListener(event, resetTimer, true);
    });
};

function resetTimer() {
    clearSessionTimer();
    // You should call startSessionTimer again from your main app component
}